import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import VortexUserProfile from "./VortexUser/UserProfile";
import Sidebar from "../components/Sidebar/Sidebar";
import User from "./User/User";
import Content from "./Content/Content";
import Notifications from "./Notifications/Notifications";
import VortexNotification from "./VortexNotifications/Notifications";
import VortexAppManager from "./VotexAppManager/AppManager";
import UserProfile from "./User/UserProfile";
import Login from "./Login/Login";
import ForgotPassword from "./Login/forgot_password";
import DataAnalysis from "./DataAnalysis/DataAnalysis";
import Settings from "./Settings/Settings";
import Security from "./Security/Security";
import Reporting from "./Reporting/Reporting";
import AppManager from "./AppManager/AppManager";
import Email from "./Email/Email";
import VortexEmail from "./VortexEmail/Email";
import VortexDataAnalysis from "./VortexDataAnalysis/DataAnalysis";
import VortexUser from "./VortexUser/User";
import AccountReset from "./Login/accountReset";

const AuthorizedCom = () => {
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("legacy");

  const handleTabChange = (tab) => {
    if (tab === "legacy") {
      navigate("/");
    } else if (tab === "vortex") {
      navigate("/vortexData");
    }
    setActiveTab(tab);
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setToken(accessToken);
    } else if (
      location.pathname !== "/login" &&
      location.pathname !== "/forgot-password" &&
      location.pathname !== "/admin-account-reset"
    ) {
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/admin-account-reset";

  if (isAuthPage) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-account-reset" element={<AccountReset />} />
      </Routes>
    );
  }

  return (
    <div>
      <div className="w-full relative bg-gray-400 overflow-hidden flex flex-col items-center justify-start pb-[2.125rem] pr-[1.5rem] pl-[2.188rem] box-border gap-[0.875rem_0rem] tracking-[normal]">
        <Navbar tab={activeTab} changeTab={handleTabChange} />

        <main className="self-stretch flex flex-row bg-black items-start justify-start gap-[0rem_0.875rem] max-w-full shrink-0 text-left text-[1.125rem] text-gray-200 font-gilroy">
          {activeTab === "legacy" && <Sidebar />}
          <Routes>
            <Route
              path="/"
              element={token ? <DataAnalysis /> : <Navigate to="/login" />}
            />
            <Route path="/user" element={<User />} />
            <Route path="/userProfile/:userId" element={<UserProfile />} />
            <Route
              path="/vortexuserProfile/:userId"
              element={<VortexUserProfile />}
            />
            <Route path="/content" element={<Content />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/security" element={<Security />} />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/AppManager" element={<AppManager />} />
            <Route path="/vortexappmanager" element={<VortexAppManager />} />
            <Route
              path="/vortexnotifications"
              element={<VortexNotification />}
            />
            <Route path="/Email" element={<Email />} />
            <Route path="/vortexData" element={<VortexDataAnalysis />} />
            <Route path="/vortexusers" element={<VortexUser />} />
            <Route path="/vortexemail" element={<VortexEmail />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AuthorizedCom;
